(function ($, Drupal) {
  Drupal.behaviors.slickInit = {
    attach: function (context, settings) {

      const $slickInit = once('heimatSlick', '.p-slider .slider-wrapper');

      $slickInit.forEach(processSlickSlider);

    }
  }

  function processSlickSlider(value, index) {
    $(value).slick({
      slide: '.field-slider-nodes, .field-gallery-images',
      slidesToShow: 2.30,
      infinite: false,
      autoplay: false,
      //autoplaySpeed: 5000,
      prevArrow: '<i class="fa-solid fa-arrow-left slick-prev"></i>',
      nextArrow: '<i class="fa-solid fa-arrow-right slick-next"></i>',
      accessibility: false,
      appendArrows: '#' + $(value).attr('id') + ' ~ .slick-arrows',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1.5,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.1
          }
        }
      ]
    });
  }

  Drupal.behaviors.HeimatSlickSliderTab = {
    attach: function (context, settings) {
      setTimeout(function () {
        if ($('.slick-slider').length) {
          $('.slick-slider').each(function () {
            $(this).on('keydown', function(e) {

              if (e.key === "Tab" && !e.shiftKey) {
                let currentSlide = $(this).slick('slickCurrentSlide');
                $(this).slick('slickGoTo', currentSlide +1, true)
              }

              if (e.key === "Tab" && e.shiftKey) {
                let currentSlide = $(this).slick('slickCurrentSlide');
                $(this).slick('slickGoTo', currentSlide -1, true)
              }
            });
          });
        }
      }, 0);
    }
  }

})(jQuery, Drupal);
